<template>
  <div></div>
</template>

<script>
export default {
  name: "commercialListItemSevenUser",
};
</script>

<style></style>
